"use client";

import React from "react";
import Chip from "@mui/material/Chip";
import { categories } from "@/utils/dabateUtil";
import { CategoryLabels } from "@/types";
import {
  AllInclusive,
  Whatshot,
  Gavel,
  AttachMoney,
  Memory,
  Diversity3,
  Home,
  Public,
  SportsSoccer,
  Museum,
  Movie,
  CurrencyBitcoin,
  Restaurant,
  Flight,
} from "@mui/icons-material";

// 카테고리 아이콘 매핑
const categoryIcons: Record<string, React.ElementType> = {
  "": AllInclusive,
  btl: Whatshot,
  pol: Gavel,
  ecn: AttachMoney,
  itc: Memory,
  soc: Diversity3,
  lif: Home,
  wld: Public,
  spt: SportsSoccer,
  cul: Museum,
  ent: Movie,
  ccy: CurrencyBitcoin,
  fod: Restaurant,
  trv: Flight,
};

interface CategoryChipProps {
  code: string;
  locale: keyof CategoryLabels;
  fontSize?: number;
}

export const CategoryChip = ({ code, locale, fontSize = 12 }: CategoryChipProps) => {
  const category = categories.find((cat) => cat.code === code);
  if (!category) return null;

  const label = category[locale] || category.en;
  const IconComponent = categoryIcons[code];

  return (
    <Chip
      icon={IconComponent ? <IconComponent sx={{ fontSize: fontSize + 4 }} /> : undefined}
      label={label}
      size="small"
      sx={{
        fontSize,
        height: fontSize + 12,
        borderRadius: fontSize + 4,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Left-align content
        "& .MuiChip-icon": {
          marginLeft: 1, // Small margin for icon spacing from left edge
          marginRight: 1, // Tight spacing between icon and label
        },
        "& .MuiChip-label": {
          paddingLeft: 0, // No extra padding on the left
          paddingRight: 2, // Small padding on the right for balance
        },
      }}
    />
  );
};
